// ------------- import external dependencies  -------------
import { useMutation, useQuery } from "@tanstack/react-query";

// ------------ import internal dependencies --------------
import {
  getUser,
  changeUserPassword,
  registerNewUser,
  updateUserDetails,
  getAllUsers,
  updateFacility,
  getUserDetails,
  uploadUserImage,
  getUserImage,
  getUserFacilities,
  checkUsername,
  changeUserStatus,
  logSupportTicket,
} from "../../../api/user";

import { useStoreWrapper } from "../../../store/store";
import { queryClient } from "../../../App";

function useUser({
  userId,
  id,
  offset = 1,
  limit = 10,
  username = "",
  searchParam,
  facility,
  role,
}: any = {}) {
  const user = useStoreWrapper((state) => state.user);

  // Queries
  const userData = useQuery(["user", userId], () => getUser(userId), {
    enabled: !!userId,
  });
  // ======
  /**
   * Get logged in user assigned facilities
   */
  const handleGetUserFacilities = useQuery(["userFacilities"], () =>
    getUserFacilities(user.userId)
  );
  // ======

  const cleanData = (data: any) => {
    const usersData = data?.data?.data[0] || data?.data?.data;
    usersData?.users?.forEach((user: any) => {
      user.facilityList = user?.Facilities?.split(":");
    });
    return usersData;
  };

  const allUserData = useQuery(
    {
      // @ts-ignore
      queryKey: ["allUser", offset],
      queryFn: () =>
        getAllUsers(user?.userId, limit, offset, searchParam, facility, role),
      select: (data: any) => cleanData(data),
    },
    { keepPreviousData: true }
  );
  // =======

  const getDetails = useQuery(["userDetails"], () => getUserDetails(id), {
    enabled: !!id,
  });
  // =======
  const handleGetLoggedinUserImage = useQuery(
    ["handleGetLoggedinUserImage"],
    () => getUserImage(user?.userId)
  );
  // =======
  // get user's accountUserNamePrefix
  const userAccountUserNamePrefix = user?.accountUsernamePrefix;

  const handleCheckUsername = async (username: string) => {
    return await checkUsername(`${userAccountUserNamePrefix}.${username}`);
  };

  // =======

  //  end of queries
  // ============================================
  // ============================================

  // Mutations
  /**
   * Handle update user details
   */
  const updateUser = useMutation((req: any) => updateUserDetails(req));

  const registerUser = useMutation((req: any) => registerNewUser(req));

  const cUserPassword = useMutation((req: any) => changeUserPassword(req));

  const updateFacilityData = useMutation((req: any) => updateFacility(req));

  const handleUploadUserImage = useMutation((req: any) => uploadUserImage(req));

  const makeUserActiveInActive = useMutation({
    mutationFn: (req: any) => changeUserStatus(req),
    onSuccess: () => {
      // @ts-ignore
      queryClient.invalidateQueries("allUser");
    },
  });

  const addSupportTicket = useMutation((req: any) => logSupportTicket(req));

  return {
    userData,
    registerUser,
    updateUser,
    cUserPassword,
    allUserData,
    updateFacilityData,
    getDetails,
    handleUploadUserImage,
    handleGetLoggedinUserImage,
    handleGetUserFacilities,
    handleCheckUsername,
    makeUserActiveInActive,
    addSupportTicket,
  };
}

export default useUser;
